module.exports = __webpack_public_path__ + "img/san_francisco.95961bd5.png";